import * as z from "zod";

export const getOutlookRecentMessages = {
  name: "getOutlookRecentMessages" as const,
  input: z.object({ integrationId: z.string(), query: z.string().optional() }),
  output: z.object({
    messages: z.array(
      z.object({
        id: z.string(),
        conversationId: z.string().optional(),
        subject: z.string().optional(),
        from: z.string().optional(),
        date: z.string().optional(),
        bodyPreview: z.string().optional(),
      }),
    ),
  }),
};
